<template>
  <div class="fixed w-full h-full inset-0 !z-50 flex justify-center items-center bg-black/45 duration-500"
       v-if="authModal" :class="{ 'visible' : authModal, 'invisible' : !authModal }">
    <div class="w-full max-w-[575px] duration-500"
         :class="{'opacity-100 scale-100': authModal, 'opacity-0 scale-50' : !authModal}">
      <div class="p-5 lg:p-[33px] bg-[transparent]">
        <div class="bg-white p-6 lg:pt-[37px] lg:pb-[14px] rounded-[20px] w-full relative">
          <div class="absolute top-[-15px] end-[-15px] z-[99999999]">
            <button type="button"
                    class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]"
                    @click="closeModal()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
                <path id="Path_2192" data-name="Path 2192"
                      d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0"
                      transform="translate(0 -0.136)" fill="#3e5463"/>
              </svg>
            </button>
          </div>
          <div class="p-4">
            <form class="h-[180px] flex items-center justify-center" @submit.prevent="login" v-if="authType == 1">
              <div class="bg-white py-[13px] w-full rounded-[20px] h-[190.4px] mb-[26px]">
                <div class="text-[22px] sm:text-[25px] font-bold text-[#35474B] uppercase mb-[7.4px]">
                  {{ lang === 'en' ? 'Login' : 'تسجيل الدخول' }}
                </div>
                <div
                    class="h-[59px] px-[15.5px] pt-[6.5px] mb-[40px] w-full rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0]">
                  <label for="phone" class="text-[16px] font-light text-[#C6A798] block">
                    {{ lang === 'en' ? 'Mobile number' : 'رقم الهاتف المحمول' }} </label>
                  <input id="phone" type="text" name="phone"
                         class="block outline-0 border-0 bg-transparent text-[#35474B] w-full"
                         autoComplete="off" v-model="phone" @keypress="validateNumber"/>
                  <div v-if="phoneError" class="text-red-700 my-2">{{ phoneError }}</div>
                </div>
                <div class="absolute bottom-[-20px] w-[90%] left-[5%]">
                  <button type="submit"
                          class="w-full rounded-[12px] h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
                          v-if="!loginLoading">
                          <span class="inline-block mt-[10px]">
                            {{ lang === 'en' ? 'Login' : 'تسجيل الدخول' }}
                          </span>
                  </button>
                  <button type="button" :disabled="true"
                          class="w-full rounded-[12px] h-[64px] bg-[#C6A798] text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
                          v-if="loginLoading">
                    <span
                        class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                  </button>
                </div>
              </div>
            </form>
            <form class="bg-white px-[19px] py-[13px] w-full rounded-[20px] h-[337.14px] pt-[21.9px] mb-[28px]"
                  @submit.prevent="verification" v-if="authType == 2">
              <div class="text-[20px] sm:text-[25px] font-normal text-center text-[#35474B] mx-auto max-w-[248px]">
                {{ lang === 'en' ? 'A confirmation Code has been Sent to' : 'لقد تم إرسال رمز التأكيد إلى' }}
              </div>
              <div
                  class="text-[20px] sm:text-[25px] font-normal text-center text-[#35474B] mx-auto mb-[5px] mt-[55px] sm:mt-[25px] sm:mb-[32.2px]">
                {{ phone }}
                <span class="text-[#C6A798]"> {{ lang === 'en' ? '(Edit)' : '(يحرر)' }} </span>
              </div>
              <div class="w-full mx-auto" :class="{'mb-6': !codeError, 'mb-3': codeError}">
                <div class="w-full flex justify-between gap-2">
                  <VOtpInput
                      v-model:value="code"
                      class="w-full justify-center gap-x-2 sm:gap-0 sm:justify-between"
                      input-classes="w-full w-[48px] h-[60px] sm:w-[61px] sm:h-[79px] rounded-[5px] bg-[#E0E9F0] outline-0 border-0 text-center text-[35px] font-bold"
                      :num-inputs="5"
                      :should-auto-focus="true"
                  />
                </div>
                <div class="text-red-700" v-if="codeError">{{ codeError }}</div>
                <div class="w-full text-[14px] text-center font-normal text-[#C6A798] mt-[4px] mb-[7px]" v-if="false">
                  {{ lang === 'en' ? 'Resending the confirmation code in' : 'إعادة إرسال رمز التأكيد في' }} 01:28
                </div>
              </div>
              <div class="absolute bottom-[-20px] w-[90%] left-[5%]">
                <button type="submit"
                        class="rounded-[12px] w-full h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 text-white uppercase text-[18px] sm:text-[21px] font-bold"
                        v-if="!verificationLoading">
                    <span class="inline-block mt-[5px]">
                      {{ lang === 'en' ? 'Verify' : 'يؤكد' }}
                    </span>
                </button>
                <button type="button" :disabled="true"
                        class="rounded-[12px] w-full h-[64px] bg-[#C6A798] text-white uppercase text-[18px] sm:text-[21px] font-bold -mb-[2px]"
                        v-if="verificationLoading">
                    <span
                        class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "@/service/apiService";
import Cookies from "js-cookie";
import VOtpInput from "vue3-otp-input";

export default {
  name: 'AuthModal',
  components: {VOtpInput},
  data(){
    return {
      authType: 1,
      lang: window?.core?.lang,
      phone: '',
      loginLoading: false,
      phoneError: null,
      code: '',
      codeError: null,
      verificationLoading: false,
    }
  },
  props: {
    authModal: {
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('handleCloseModal');
    },

    async login() {
      try {
        this.phoneError = null;
        if (!this.phone) {
          this.phoneError = `${this.lang === 'en' ? 'Phone number is required.' : 'رقم الهاتف مطلوب.'}`;
          return;
        }
        this.loginLoading = true;
        const url = `/Login`;
        const response = await ApiService.post(url, {phone: this.phone});
        if (response?.data?.error?.phone.length > 0) {
          this.phoneError = response?.data?.error?.phone[0];
          return;
        }
        if (response.data.status === 200) {
          this.authType = 2;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loginLoading = false;
      }
    },

    async verification() {
      try {
        this.codeError = null;
        if(!this.code || this.code.split('').length != 5){
          this.codeError = `${this.lang === 'en' ? 'Please fill up the input fields.' : 'يرجى ملء حقول الإدخال.'}`;
          return;
        }
        this.verificationLoading = true;
        const url = `/verify/code`;
        const data = {
          phone: this.phone,
          code: Object.values(this.code).join('')
        }
        const response = await ApiService.post(url, data);
        if(response.data.status === 204){
          const user = await this.createClient();
          if(user.data.status === 200 ){
            const data = JSON.stringify(user.data.data);
            Cookies.set('user_info', data)
            Cookies.set('access_token', user.data.token)
            window.location.reload();
          }
        }else if(response.data.status === 200) {
          const data = JSON.stringify(response.data.data);
          Cookies.set('user_info', data)
          Cookies.set('access_token', response.data.token)
          window.location.reload();
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.verificationLoading = false;
      }
    },

    async createClient() {
      try {
        const data = {
          name: 'yousef',
          gender: 'm',
          city: 'jeddah',
          phone: this.phone,
          birth_date: '2000-02-12',
          location: {
            lat: '23.170664',
            long: '89.212418',
            alt: '561561.651'
          }
        };
        const url = `/create/client`;
        const response = await ApiService.post(url, data);
        return response;
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },

    validateNumber(evt) {
      evt.stopPropagation();
      var theEvent = evt || window.event;

      // Handle paste
      if (theEvent.type === 'paste') {
        // @ts-ignore
        key = event.clipboardData.getData('text/plain');
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /^\d*\.?\d*$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
}
</script>